// import components
import {
  Button,
  ButtonProps,
  Checkbox,
  CheckboxProps,
  styled,
  TextField,
  TextFieldProps
} from '@mui/material';
import { NOTE_VARIANT } from '../Notes.consts';
import { NoteVariant } from '../Notes.types';

export const StyledNotesTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'noteVariant'
})<TextFieldProps & { noteVariant?: NoteVariant }>(
  ({ theme, noteVariant = NOTE_VARIANT.DEFAULT }) => ({
    backgroundColor:
      noteVariant === NOTE_VARIANT.ALTERNATIVE
        ? theme.palette.background.paper
        : theme.palette.background.default,
    borderTopLeftRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius,

    '& .MuiInputBase-inputMultiline': {
      padding: theme.spacing(2, 4)
    }
  })
);

export const StyledNoteFormButton = styled(Button)<ButtonProps>(() => ({
  width: 'max-content',
  marginLeft: 'auto'
}));

export const StyledCompactCheckboxHeight = styled(Checkbox)<CheckboxProps>(
  () => ({
    height: '32px'
  })
);
